import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck'
import { faExclamation } from '@fortawesome/pro-regular-svg-icons/faExclamation'
import { faInfo } from '@fortawesome/pro-regular-svg-icons/faInfo'
import { faWarning } from '@fortawesome/pro-regular-svg-icons/faWarning'
import { Box, Loader } from '@mantine/core'
import { notifications } from '@mantine/notifications'
import { type ReactNode } from 'react'

import { Icon } from '../Icon/Icon'

export type NotificationOptions = {
  type?: 'info' | 'success' | 'error' | 'warning' | 'loading'
  title?: ReactNode
  message: ReactNode
}

export function useNotifications() {
  const showNotification = ({
    type = 'info',
    title,
    message,
  }: NotificationOptions) => {
    const map = {
      info: {
        color: 'blue',
        icon: <Icon icon={faInfo} />,
      },
      success: {
        color: 'green',
        icon: <Icon icon={faCheck} />,
      },
      error: {
        color: 'red',
        icon: <Icon icon={faExclamation} />,
      },
      warning: {
        color: 'orange',
        icon: <Icon icon={faWarning} />,
      },
      loading: {
        color: 'transparent',
        icon: (
          <Box bg='white'>
            <Loader size='md' mt={8} />
          </Box>
        ),
      },
    }

    const { color, icon } = map[type]

    return notifications.show({
      color,
      icon,
      title,
      message,
      bottom: 55,
    })
  }

  return { showNotification }
}
